import { render } from "./BuildInformation.vue?vue&type=template&id=7fa54b62&scoped=true"
import script from "./BuildInformation.vue?vue&type=script&lang=js"
export * from "./BuildInformation.vue?vue&type=script&lang=js"

import "./BuildInformation.vue?vue&type=style&index=0&id=7fa54b62&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fa54b62"]])

export default __exports__